export default __webpack_public_path__ + "static/media/view.d18d9677.svg";